module.exports = __webpack_public_path__ + "static/media/brav.6bf0e260.mp3";